/* globals cpac, $j, $ */

if (typeof cpac !== 'undefined') {
    cpac.form = {
        submitToNewWindow: function (form, url) {
            var formObj = $j(form);
            var formTarget = formObj.attr('target');
            var formAction = formObj.attr('action');
            
            if (typeof (url) != 'undefined') {
                formObj.attr('action', url);
            }
            
            formObj.attr('target', '_blank');
            formObj.submit();
            
                // restore form attributes
            formObj.attr('target', formTarget);
            formObj.attr('action', formAction);
            return false;
        }
    }

    cpac.form.element = {
        focus: function (el) {
            $j(el).addClass('active-input');
        },
        
        blur: function (el) {        
            $j(el).removeClass('active-input');
        }
    }

    cpac.form.checkbox = {
        toggle: function (divObj) {
            try {
                var inputObj = $(divObj).down('input', 0);
                var curValue = parseFloat(inputObj.value);
                if (curValue == 0) {
                    this.turnOn(divObj, inputObj);
                } else {
                    this.turnOff(divObj, inputObj);
                }
            } catch(e) {
                cpac.error(e)
            }
        },
        turnOn: function (divObj, inputObj) {
            if (inputObj == undefined) {
                inputObj = $(divObj).down('input', 0);
            }
            var prevValue = inputObj.value;
            inputObj.value = 1;
            Element.addClassName(divObj, 'btn-trigger-yes');
            Element.removeClassName(divObj, 'btn-trigger-no');
            if (prevValue != inputObj.value && inputObj.onchange != undefined) {
                inputObj.onchange();
            }
        },
        turnOff: function (divObj, inputObj) {
            if (inputObj == undefined) {
                inputObj = $(divObj).down('input', 0);
            }
            var prevValue = inputObj.value;
            inputObj.value = 0;
            Element.addClassName(divObj, 'btn-trigger-no');
            Element.removeClassName(divObj, 'btn-trigger-yes');
            if (prevValue != inputObj.value && inputObj.onchange != undefined) {
                inputObj.onchange();
            }
        }
    }

    cpac.form.toggle = {
        toggle: function (linkObj, textOn, textOff) {
            try {
                var value = Element.hasClassName(linkObj, 'checkbox-on') ? 0 : 1;
                var inputObj = linkObj.nextSibling;
                var fromClassName = value == 1 ? 'checkbox-off' : 'checkbox-on';
                var toClassName = value == 1 ? 'checkbox-on' : 'checkbox-off';
                var text = value == 1 ? textOn : textOff;
                if (inputObj) {
                    inputObj.value = value;
                    Element.removeClassName(linkObj, fromClassName);
                    Element.addClassName(linkObj, toClassName);
                    linkObj.innerHTML = text;
                }
            } catch(e) {
                cpac.error(e)
            }
        }
    }

    cpac.form.toggleWithInput = {
        toggle: function (linkObj, textOn, textOff) {
            try {
                var value         = Element.hasClassName(linkObj, 'checkbox-on') ? 0 : 1;
                var hiddenObj     = linkObj.nextSibling;
                var inputObj      = hiddenObj.nextSibling;
                var fromClassName = value == 1 ? 'checkbox-off' : 'checkbox-on';
                var toClassName   = value == 1 ? 'checkbox-on' : 'checkbox-off';
                var text          = value == 1 ? textOn : textOff;
                var displayInput  = value == 1 ? 'inline' : 'none';
                if (hiddenObj) {
                    hiddenObj.value = value;
                    Element.removeClassName(linkObj, fromClassName);
                    Element.addClassName(linkObj, toClassName);
                    linkObj.innerHTML = text;
                    inputObj.style.display = displayInput;
                }
            } catch(e) {
                cpac.error(e)
            }
        }
    }


    cpac.form.buttontabs = {
        tab_class: 'button-tab',
        div_class: 'button-tab-div',
        select: function (buttonObj, valueObj, value) {
            try {
                buttonObj = $j(buttonObj);
                valueObj =  $j(valueObj);

                buttonObj.parent().children('.' + this.tab_class).removeClass('pushed');
                buttonObj.addClass('pushed');
                valueObj.val(value);
                buttonObj.parent().children('.' + this.div_class).hide();
                buttonObj.parent().children('#' + this.div_class + '-'+value).show();

            }catch(e) {
                cpac.error(e)
            }
        }
    }

    cpac.form.select = {
        hideDefault: function (selectObj) {
            /*
            var firstNode = selectObj.options[0];
            if (firstNode && (firstNode.value == '' || firstNode.value == '0')) {
                selectObj.removeChild(firstNode);
            }
            */
            $(selectObj).removeClassName('default');
        }
    }

    cpac.form.phone = {
        currentEl: null,
        
        setElement: function (el) {
            this.currentEl = el;
        },
        
        nextInput: function(el) {
            if (this.currentEl != el) {
                return; 
            }
            
            if (el.value && el.value.length == '3') {   //enter phone
                $j(el).next().focus().select();
            } else if (el.value == '') {    // erase phone
                $j(el).prev().focus().select();
            }
        }    
    }


    cpac.formSelect = function(p) {
        if( p.options && p.options[ p['default'] ] ) {
            var defaultOption = p.options[ p['default'] ];
        }

        if( typeof defaultOption != 'object' ) {
            defaultOption = {
                key: p['default']
                ,
                text: defaultOption
                ,
                comment: ''
            }
        } else {
            p['default'] = p['default'] ? p['default'] : 0;
            defaultOption = {
                text: p.defaultText
            }
        }

        var className = typeof p.className != 'undefined' ? p.className : '';

        if( typeof p.name != 'string' ) {
            p.name = '';
        }

        if( typeof p.onChange != 'string' ) {
            p.onChange = '';
        }

        var pId = p.name.replace('[', '-');
        pId = pId.replace(']', '');

        // draw select input
        var echo = '';
        echo += '<div id="'+pId+'-select-caption" class="select '+className+'" ';
        echo += 'onclick="formSelect.toggle(\'hidden_filter_'+pId+'\');">';
        echo += '<div class="select-arrow">';
        echo += '<div id="filter-description" class="right-oriented">'+defaultOption['comment']+'</div>';
        echo += '<strong>'+defaultOption['text']+'</strong>';
        echo += '</div>';
        echo += '</div>';

        // draw options
        echo += '<div id="hidden_filter_'+pId+'" class="hidden-filter '+className+'" style="display: none;">';
        if( p.options && typeof p.options == 'object' ) {
            for( var k in p.options ) {
                if( ! p.options.hasOwnProperty(k)) {
                    continue;
                }
                var option = p.options[k];
                var key = typeof option == 'object' && typeof option.key != 'undefined' ? option.key : k;
                var isCaption = typeof option == 'object' && option.isCaption ? true : false;
                var klass = k == p['default'] && !isCaption ? ' selected' : ( isCaption ? 'caption' : '' );
                var changeToSelected = p.noselect ? 0 : 1;
                var onclick = typeof option == 'object' && option.onclick ? option.onlick : '';
                onclick += isCaption ? '' : "formSelect.selectOption(this, this.parentNode.parentNode, '"+pId+"', '"+key+"', "+changeToSelected+")";
                var text = typeof option == 'object' ? option.text : option;
                var comment = typeof option == 'object' ? option.comment : '';
                var extra = typeof option == 'object' && option.extra ? option.extra : '';
                echo += '<div class="row-block">';
                echo += '<a class="row '+klass+'" href="javascript:void(0)" onclick="'+onclick+'" '+extra+'>';
                echo += text;
                echo += '<div class="comment">'+comment+'</div>';
                echo += '</a>';
                echo += '</div>';
            }
        } else {
            echo += '<div class="block">';
            echo += '<a class="row" href="javascript:void(0)">&nbsp;</a>';
            echo += '</div>';
        }
        echo += '</div>';

        echo += '<input type="hidden" id="'+pId+'" onchange="'+p.onChange+'" value="'+p['default']+'" name="'+p.name+'" />';

        return echo;
    }

    // common function to set .00 in prices
    cpac.formUpdatePriceToUSStandard = function(elementOrJquerySelector){
        var jObj = $j(elementOrJquerySelector);
        // get price
        var $isInput = (jObj[0].tagName.toLowerCase() == 'input');
        var price = ($isInput) ? jObj.val() : jObj.html() ; // we distinct inputs an others
        price = Math.round(price * 100) / 100; // this line is because IE implement toFixed() wrong in old versions
        price = price.toFixed(2);
        // update price
        if($isInput){
            jObj.val(price);
        }else{
            jObj.html(price);
        }
    }

    /**
     * Unti-CSRF tokens
     */
    cpac.form.token = {
        pool: {},

        set: function (name, value) {
            this.pool[name] = value;
        },

        get: function (name) {
            if (typeof (this.pool[name]) != undefined) {
                return this.pool[name];
            }
            return '';
        },

        toString: function (name) {
            var value = this.get(name);
            return '&' + name + '=' + value;
        }
    }
}